import { colors } from "constants/colors";
import styled from "styled-components";

export type StyledDateInputProps = {
  height?: string;
  width?: string;
};

export const StyledDateInput = styled.div`
  .styled {
    background: ${colors.form.background};
    font-size: 16px;
    height: ${({ height }: StyledDateInputProps) => height || "2rem"};
    width: ${({ width }: StyledDateInputProps) => width || "10rem"};
    padding: 0.5rem 0.75rem 0.5rem;
    box-sizing: border-box;
    border-radius: 5px;
    border: 0px;

    &:disabled {
      background: ${colors.disable};
    }

    &:focus {
      background: ${colors.form.focused};
    }
  }
`;
